// extracted by mini-css-extract-plugin
module.exports = {"page-container":"marketplace-home_page-container__3kpc_","categories":"marketplace-home_categories__B_QCd","product-card":"marketplace-home_product-card__2fWxx"};